import { render, staticRenderFns } from "./ps.vue?vue&type=template&id=620d4be8"
import script from "./ps.vue?vue&type=script&lang=js"
export * from "./ps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports